import React from 'react'
import LoginComponent from '../../@b_components/login/login.component'
import withLoader, {WithLoaderProps} from '../../@hoc/withloader/withloader.hoc'

const LoginContainer: React.FC<WithLoaderProps> = function (props) {
  return <LoginComponent {...props} />
}

export default withLoader(LoginContainer)
